(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/standard-flow/assets/javascripts/standard-payment-flow.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/standard-flow/assets/javascripts/standard-payment-flow.js');
"use strict";


const createPayment = svs.components.payment.payment.createPayment;
const grassroots = svs.components.payment.middleware.grassroots;
const authenticated = svs.components.payment.middleware.authenticated.authenticated;
const _svs$components$wager = svs.components.wagerPaymentFlow.standardFlow.middlewareSetup,
  accountBalanceMW = _svs$components$wager.accountBalanceMW,
  competitionMW = _svs$components$wager.competitionMW,
  spelpausMW = _svs$components$wager.spelpausMW,
  paymentConfirmMw = _svs$components$wager.paymentConfirmMw,
  paymentDoneMW = _svs$components$wager.paymentDoneMW,
  timeLimitsMW = _svs$components$wager.timeLimitsMW;
const WagerService = svs.components.payment.serviceWager.WagerService;

const createStandardPaymentFlow = _ref => {
  let config = _ref.config,
    wagers = _ref.wagers,
    _ref$extraPreMW = _ref.extraPreMW,
    extraPreMW = _ref$extraPreMW === void 0 ? [] : _ref$extraPreMW,
    _ref$extraPostMW = _ref.extraPostMW,
    extraPostMW = _ref$extraPostMW === void 0 ? [] : _ref$extraPostMW,
    callback = _ref.callback;
  const paymentBuilder = createPayment(new WagerService(config)).addPayable(...wagers).addPreMiddleware(authenticated).addPreMiddleware(spelpausMW).addPreMiddleware(timeLimitsMW).addPreMiddleware(accountBalanceMW).addPreMiddleware(competitionMW);
  if (extraPreMW.length > 0) {
    extraPreMW.forEach(preMW => paymentBuilder.addPreMiddleware(preMW));
  }
  paymentBuilder.addPreMiddleware(paymentConfirmMw(callback));
  paymentBuilder.addPostMiddleware(paymentDoneMW);
  if (extraPostMW.length > 0) {
    extraPostMW.forEach(postMW => paymentBuilder.addPostMiddleware(postMW));
  }
  paymentBuilder.addPostMiddleware(grassroots);
  return paymentBuilder;
};
setGlobal('svs.components.wagerPaymentFlow.standardFlow.createStandardPaymentFlow', createStandardPaymentFlow);

 })(window);